<template >
  <!--begin::Content-->
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Subheader-->
    <sub-header :titulo="titulo" :buttons="buttons"></sub-header>
    <!--end::Subheader-->
    <!--begin::Entry-->
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container">
        <!--begin::Dashboard-->
        <!--begin::Row-->

        <Listagem
          :dados="dados"
          :colunas="colunaPadrao"
          :colunasDetalhes="colunas"
          :monta="monta"
          :exportacao="exportarLista"
          :canVer="false"
          :canInativar="user.leitura != true"
          @onVisualizar="visualizar"
          @onDelete="inativar"
          @onEditar="editar"
        />

        <!-- Button trigger modal-->
        <!-- <button
          type="button"
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#exampleModal"
        >Visualizar Funcionário</button>-->

        <!-- Modal-->
        <div
          class="modal fade bd-example-modal-xl"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myExtraLargeModalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-xl modal-dialog-scrollable"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Visualizando cliente
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i aria-hidden="true" class="ki ki-close"></i>
                </button>
              </div>
              <div class="modal-body" style="height: 500px">...</div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light-primary font-weight-bold"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--end::Row-->
        <!--end::Dashboard-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::Entry-->
  </div>
  <!--end::Content-->
</template>
<script>
import Listagem from "../../components/forms/Listagem.vue";
import SubHeader from "../../components/layout/SubHeader";
import { mapActions, mapState } from "vuex";
import utils from "@/utils";
export default {
  components: {
    Listagem,
    SubHeader,
  },
  data: () => ({
    export: [
      {
        descricaoPai: "Usuário",
        criaSheet: true,
        campos: [
          {
            header: "ID",
            field: "id_usuario",
            checked: false,
          },
          {
            header: "Funcionário",
            field: "funcionario.pessoa.nome",
            checked: false,
          },
          {
            header: "Função",
            field: "funcionario.funcao",
            checked: false,
          },
          {
            header: "Login(Email)",
            field: "login",
            checked: false,
          },
        ],
      },
      {
        descricaoPai: "Perfil de Acesso",
        criaSheet: true,
        dados: "funcionalidadesHabilitadas",
        campos: [
          {
            header: "ID",
            field: "id_usuario",
            checked: false,
            hidden: true,
          },
          {
            header: "Funcionário",
            field: "funcionario.pessoa.nome",
            checked: false,
            hidden: true,
          },
          {
            header: "Login(Email)",
            field: "login",
            checked: false,
            hidden: true,
          },
          {
            header: "Menu",
            field: "funcionalidade.menu",
            checked: false,
          },
          {
            header: "Acesso",
            field: "funcionalidade.descricao",
            checked: false,
          },
        ],
      },
      {
        descricaoPai: "Empresas",
        criaSheet: true,
        dados: "empresasHabilitadas",
        campos: [
          {
            header: "ID",
            field: "id_usuario",
            checked: false,
            hidden: true,
          },
          {
            header: "Funcionário",
            field: "funcionario.pessoa.nome",
            checked: false,
            hidden: true,
          },
          {
            header: "Login(Email)",
            field: "login",
            checked: false,
            hidden: true,
          },
          {
            header: "Empresa",
            field: "empresa.pessoa.nome",
            checked: false,
          },
        ],
      },
    ],
    buttons: [
      {
        link: "/usuario/0",
        titulo: "Add novo Usuário",
      },
    ],
    titulo: "Usuários",
    colunaPadrao: [
      {
        label: "Nome",
        field: "funcionario.pessoa.nome",
      },
      {
        label: "Função",
        field: "funcionario.funcao",
      },
      {
        label: "Login",
        field: "login",
      },
      {
        label: "Ação",
        field: "id_usuario",
      },
    ],
    colunas: [
      {
        nome: "Nome",
        index: "funcionario.pessoa.nome",
        isHtml: false,
      },
      {
        nome: "Função",
        index: "funcionario.funcao",
        isHtml: false,
      },
      {
        nome: "Login",
        index: "login",
        isHtml: false,
      },
    ],
    dados: [],
    monta: false,
  }),
  computed: {
    ...mapState("auth", ["user"]),
    exportarLista: {
      get() {
        return this.export;
      },
      set(nValue) {
        this.export = nValue;
      },
    },
  },
  mounted() {
    window.KTApp.block("#kt_blockui_content", {
      overlayColor: "#000000",
      state: "primary",
      message: "Processando...",
    });
    if (this.user.leitura == true) {
      this.buttons = [];
    }
    this.ActionGetListUsuarios()
      .then((r) => {
        this.dados = r;
        this.dados.forEach((el) => {
          if (el.funcionario) {
            el.funcionario.pessoa.identificador =
              el.funcionario.pessoa.identificador.length == 14
                ? utils.formatarCnpj(el.funcionario.pessoa.identificador)
                : utils.formatarCpf(el.funcionario.pessoa.identificador);
          }
        });
        this.monta = true;
        window.KTApp.unblock("#kt_blockui_content");
      })
      .catch((error) => {
        if (error.data) {
          console.log(error.data);
          this.$swal.fire({
            icon: "error",
            title: error.data.error.title || "Oops...",
            text: error.data.error.message,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Ocorreu um erro inesperado, favor contactar o suporte.",
          });
        }
      });
  },
  methods: {
    ...mapActions("usuario", ["ActionGetListUsuarios", "ActionInativaUser"]),
    load() {
      this.ActionGetListUsuarios().then((r) => {
        this.dados = r;
        this.monta = true;
      });
    },
    visualizar(item) {
      console.log(item);
    },
    inativar(item) {
      console.log(item);
      this.$swal
        .fire({
          icon: "question",
          title: "Atenção",
          text: "Deseja realmente inativar este usuario ?",
          showCloseButton: true,
          showCancelButton: true,
          showConfirmButton: true,
          cancelButtonText: "Não",
          confirmButtonText: "Sim",
        })
        .then((r) => {
          if (r.value) {
            this.ActionInativaUser(item.id_usuario).then((r) => {
              if (r.sucesso == true) {
                this.$swal.fire({
                  icon: "success",
                  title: "Sucesso",
                  text: "Usuario inativado com sucesso",
                });
              }
              this.load();
            });
          }
        });
    },
    editar(item) {
      this.$router.push(`/usuario/${item.id_usuario}`);
    },
  },
};
</script>